import { formatBilletInput, moneyFormat } from '@portal/utils/format';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { TRANSACTION_GENERATE_BILLET_DETAILS } from '~/actions/actionTypes';
import ThemedText from '@portal/components/ThemedText/ThemedText';
import { translate } from '@portal/services/i18n';
interface IProps {
  billetCode?: string;
  amount?: number;
}

const GenerateBilletConfirmation = (props: IProps) => {
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch({
        payload: null,
        type: TRANSACTION_GENERATE_BILLET_DETAILS,
      });
    };
  }, [dispatch]);

  return (
    <div className="generate-billet-confirmation">
      <ThemedText variant="body" className="generate-billet-confirmation__text">
        {translate('COMPONENTS.GENERATE_BILLET_CONFIRMATION.YOUR_TICKED')}{' '}
        <span className="generate-billet-confirmation__amount">
          {moneyFormat(props.amount as number)}
        </span>{' '}
        {translate('COMPONENTS.GENERATE_BILLET_CONFIRMATION.GENERATED')}
      </ThemedText>
      <ThemedText
        variant="body"
        className="generate-billet-confirmation__billet-code"
      >
        {typeof props.billetCode === 'string'
          ? formatBilletInput(props.billetCode)
          : ''}
      </ThemedText>
      <ul className="generate-billet-confirmation__list">
        <li>
          {translate(
            'COMPONENTS.GENERATE_BILLET_CONFIRMATION.DESCRIPTIONS.ONE'
          )}
        </li>
        <li>
          {translate(
            'COMPONENTS.GENERATE_BILLET_CONFIRMATION.DESCRIPTIONS.TWO'
          )}
        </li>
        <li>
          {translate(
            'COMPONENTS.GENERATE_BILLET_CONFIRMATION.DESCRIPTIONS.THREE'
          )}
        </li>
      </ul>
    </div>
  );
};

export default GenerateBilletConfirmation;
